import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { toast } from "react-toastify";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import { getMyProfile, updateMyProfile } from "../../slices/4-profile/thunk";
import profileimg from "../../assets/images/images.jpeg";
const Setting = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.Profile);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [avatar, setAvatar] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [showPassword, setShowPassword] = useState(true);
  useEffect(() => {
    dispatch(getMyProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile) {
      setFirstName(profile.firstName || "");
      setLastName(profile.lastName || "");
      setEmail(profile.email || "");
      setPhone(profile.phone || "");
      setAvatar(profile.avatar || "");
    }
  }, [profile]);

  const handleUpdateProfile = () => {
    dispatch(
      updateMyProfile({
        firstName,
        lastName,
        avatar,
      }),
    );
  };

  const handleChangePassword = () => {
    if (!newPassword || !confirmPassword) {
      toast.error("من فضلك املأ كل الحقول");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("كلمة المرور غير متطابقة");
      return;
    }

    dispatch(
      updateMyProfile({
        oldPassword,
        newPassword,
      }),
    );
  };

  document.title = "Setting";

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // console.log(profile);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="الإعدادات" />
          <Row>
            <Col lg={12}>
              <Card style={{ borderRadius: "16px" }}>
                <CardBody>
                  {/* Tabs */}
                  <Nav tabs className="mb-4">
                    <NavItem>
                      <NavLink
                        className={activeTab === "1" ? "active" : ""}
                        onClick={() => toggleTab("1")}
                        style={{ cursor: "pointer" }}
                      >
                        حسابي
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={activeTab === "2" ? "active" : ""}
                        onClick={() => toggleTab("2")}
                        style={{ cursor: "pointer" }}
                      >
                        الأمان
                      </NavLink>
                    </NavItem>
                  </Nav>

                  {/* Content */}
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <Card className="border-0">
                        <CardBody>
                          <div className="d-flex justify-content-between align-items-start mb-4 flex-column">
                            <div>
                              <h5 className="mb-3 ">بيانات الحساب</h5>
                            </div>

                            <div className="d-flex align-items-center gap-3">
                              <img
                                src={
                                  profile?.avatar ? profile?.avatar : profileimg
                                }
                                alt=""
                                className="rounded-circle"
                                width="50"
                              />
                              <div className="text-start">
                                <h6 className="mb-0">{`${firstName} ${lastName}`}</h6>
                                <small className="text-muted">{email}</small>
                                <div className="text-success small">
                                  {profile?.role}
                                </div>
                              </div>
                            </div>
                          </div>

                          <Row className="g-3">
                            <Col md={6}>
                              <label>الاسم الكامل</label>
                              <input
                                className="form-control"
                                value={`${firstName} ${lastName}`}
                                disabled
                                onChange={(e) => {
                                  const val = e.target.value.split(" ");
                                  setFirstName(val[0] || "");
                                  setLastName(val[1] || "");
                                }}
                              />
                            </Col>

                            <Col md={6}>
                              <label>البريد الإلكتروني</label>
                              <input
                                className="form-control"
                                value={email}
                                disabled
                              />
                            </Col>

                            <Col md={6}>
                              <label>رقم الهاتف</label>
                              <input
                                className="form-control"
                                value={phone}
                                disabled
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </Col>

                            <Col md={6}>
                              <label>الدور</label>
                              <input
                                className="form-control"
                                disabled
                                value={profile?.role}
                              />
                            </Col>
                          </Row>

                          {/* <div className="text-end mt-4">
                            <Button
                              color="success"
                              onClick={handleUpdateProfile}
                            >
                              حفظ التعديلات
                            </Button>
                          </div> */}
                        </CardBody>
                      </Card>
                    </TabPane>

                    {/* ===== TAB 2: الأمان ===== */}
                    <TabPane tabId="2">
                      <Card className="border-0">
                        <CardBody>
                          <h5 className="mb-4">تغيير كلمة المرور</h5>

                          <Row className="g-3">
                            <Col md={12}>
                              <label>كلمة المرور الحالية</label>
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                              />
                            </Col>

                            <Col md={12}>
                              <label>كلمة المرور الجديدة</label>
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                              />
                            </Col>

                            <Col md={12}>
                              <label>تأكيد كلمة المرور الجديدة</label>
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                value={confirmPassword}
                                onChange={(e) =>
                                  setConfirmPassword(e.target.value)
                                }
                              />
                            </Col>
                          </Row>

                          <div className="text-end mt-4">
                            <Button
                              color="success"
                              onClick={handleChangePassword}
                            >
                              تغيير كلمة المرور
                            </Button>
                          </div>
                        </CardBody>
                      </Card>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Confirm Toggle Block Modal */}
      {/* <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          تأكيد الإجراء
        </ModalHeader>
        <ModalBody>
          <div className="mt-2 text-center">
            <i
              className={`ri-information-line display-3 ${isBlockedStatus ? "text-success" : "text-danger"}`}
            ></i>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>هل أنت متأكد؟</h4>
              <p className="text-muted mx-4 mb-0">
                هل تريد حقاً {isBlockedStatus ? "إلغاء حظر" : "حظر"} هذا
                المستخدم؟
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-center w-100">
            <Button color="light" onClick={() => setDeleteModal(false)}>
              إلغاء
            </Button>
            <Button
              color={isBlockedStatus ? "success" : "danger"}
              onClick={confirmToggleBlock}
            >
              نعم، {isBlockedStatus ? "إلغاء الحظر" : "إتمام الحظر"}
            </Button>
          </div>
          </ModalFooter>
        </Modal> */}
    </React.Fragment>
  );
};

export default Setting;
